import dynamic from 'next/dynamic'
import React from 'react'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { PropertyRecordsIcon } from 'src/components/insights/icons/property-records'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { Colors } from 'src/components/theme'
import InsightLocked from 'src/components/insight-locked'
import { useTier } from 'src/hooks/use-tier'

import propertyRecords1 from 'src/assets/images/insights-previews/property-records/property_records_1.gif'
import propertyRecords1Placeholder from 'src/assets/images/insights-previews/property-records/property_records_1.png'
import propertyRecords2 from 'src/assets/images/insights-previews/property-records/property_records_2.gif'
import propertyRecords2Placeholder from 'src/assets/images/insights-previews/property-records/property_records_2.png'
import propertyRecords3 from 'src/assets/images/insights-previews/property-records/property_records_3.gif'
import propertyRecords3Placeholder from 'src/assets/images/insights-previews/property-records/property_records_3.png'
import { INSIGHTS_TIER } from 'src/constants/insights-tier'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'

const PropertyDetailsContent = dynamic(() => import('src/components/insights/property-records/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const PropertyRecordsPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props
  const meetsTier = useTier(INSIGHTS_TIER['Property Records'])

  return (
    <InsightContainer insight={insight} color={Colors.orangeDark}>
      <React.Suspense fallback={<FullScreenLoading />}>
        {!meetsTier ? <InsightLocked insight={insight} /> : <PropertyDetailsContent />}
      </React.Suspense>
    </InsightContainer>
  )
}

export const PropertyRecords: Insight = {
  id: 'property-details',
  component: PropertyRecordsPage,
  name: 'Property Records',
  icon: PropertyRecordsIcon,
  supportedResultTypes: ['venue', 'address', 'alphamap-location'],
  linkTooltipFile: 'insights-link-property-records',
  tier: INSIGHTS_TIER['Property Records'],
  paywall: {
    title: 'See Property Record Reports in Action',
    description: `Property Record Reports aren't available on your current plan. However, you can view full functionality of this feature by viewing an unlocked location or upgrading your plan below.`,
    synopsis: [
      {
        image: propertyRecords1.src,
        imagePlaceholder: propertyRecords1Placeholder.src,
        title: 'Property Deep Dive',
        description: 'Discover tenant details and physical attributes at a glance for strategic property insights.',
      },
      {
        image: propertyRecords2.src,
        imagePlaceholder: propertyRecords2Placeholder.src,
        title: 'Ownership Uncovered',
        description: "Instantly reveal a property's ownership journey and key contacts.",
      },
      {
        image: propertyRecords3.src,
        imagePlaceholder: propertyRecords3Placeholder.src,
        title: 'Financial Backstory',
        description: 'Access a snapshot of property tax and debt history for smart financial assessments.',
      },
    ],
  },
}
